// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__i_Flg","title":"Header_title__fZLWk","left":"Header_left__35Cs_","clinicName":"Header_clinicName__1fjCJ"};